module.exports = __webpack_public_path__ + "img/96.2eadb11.png";